import { api } from "../../api/endpoints";
import {
  DELETE_SCREEN,
  DELETE_SCREEN_REQUEST,
  GET_ALL_SCREEN_SUCCESS,
  GET_ONE_SCREEN,
  SCREEN_REGISTER,
  SCREEN_REGISTER_FLAG_OFF,
  SCREEN_STATUS_ACTIVE,
  SCREEN_STATUS_DEACTIVE,
  EDIT_SCREEN,
  SCREEN_MOVE_TO_FOLDER,
  SCREEN_PAIRED,
  SCREEN_UNPAIRED,
  SCREEN_NO_DATA_LOGS,
  SET_ASAP_UPDATE_FAILED,
  SET_PENDING_STATUS_FAILED,
  SCREEN_DUPLICATE_NAMES_ERROR,
  GET_SCREEN_DETAILS_ERROR,
  ADD_SCREEN_DETAILS_TO_LIST,
  SCREEN_ERROR,
  SCREEN_UPDATE_V2,
} from "../constant";

// export const registerScreen = (code, obj) => {
//   return async (dispatch) => {
//     try {
//       const updatedScreen = await api.patch(`/screen/screenregister/${code}`, {...obj, origin: 'screen'});
//       if (updatedScreen.status === 201) {
//         dispatch({
//           type: SCREEN_REGISTER,
//           payload: updatedScreen.data.updatedScreen,
//         });
//         return updatedScreen.data.updatedScreen; // Return the updated screen data
//       }
//     } catch (error) {
//       if(error?.response?.data?.message == 'duplicate'){
//         dispatch({
//           type: SCREEN_DUPLICATE_NAMES_ERROR,
//           payload: true
//         })

//         setTimeout(() => {
//           dispatch({
//               type: SCREEN_DUPLICATE_NAMES_ERROR,
//               payload: false
//             })
//         }, 4000)
//       }else{
//         console.error("Error registering screen:", error);
//         throw error; // Rethrow the error so we can catch it in the component
//       }
//     }
//   };
// };

export const registerScreenv2 = (code, obj) => {
  return async (dispatch) => {
    try {
      const updatedScreen = await api.patch(`/screen/screenregister/${code}`, {...obj, origin: 'screen'});
      if(updatedScreen.status == 201) {
        dispatch({
          type: SCREEN_REGISTER,
          payload: updatedScreen.data.updatedScreen,
        });
        return updatedScreen.data.updatedScreen
      }
    } catch (err) {
      dispatch ({
        type: SCREEN_ERROR,
        payload: err?.response?.data?.error
      })
    }
  }
}

export const updateScreenv2 = (obj) => {
  return async (dispatch) => {
    try {
      const updatedScreen = await api.patch(`/screen/screenupdate`, {...obj});
      if(updatedScreen.status == 201) {
        if(obj.id){
          dispatch({
            type: EDIT_SCREEN,
            payload: updatedScreen.data.updatedScreen,
          });
        }else {
          dispatch({
            type: SCREEN_REGISTER,
            payload: updatedScreen.data.updatedScreen,
          });
        }
        return updatedScreen.data.updatedScreen
      }
    } catch (err) {
      dispatch ({
        type: SCREEN_ERROR,
        payload: err?.response?.data?.error
      })
    }
  }
}

export const switchOfflineMode = (statusToSet, id) => {
  return async (dispatch) => {
    const { status, data } = await api.patch('/screen/switchOfflineMode', {
      id: id,
      status: statusToSet
    })
    console.log(data)
    if(status == 200) {
      dispatch({
        type: EDIT_SCREEN,
        payload: data.updatedScreen,
      });
    }
  }
}

export const resetScreenError = () => {
  return async (dispatch) => {
    dispatch({
      type: SCREEN_ERROR,
      payload: ''
    })
  }
}

// export const updateScreen = (id, obj) => {
//   return async (dispatch) => {
//     try {
//       const updatedScreen = await api.patch(`/screen/screenupdate/${id}`, {
//         preventLastActive: true,
//         origin: 'screen',
//         ...obj
//       });
//       if (updatedScreen.status === 201) {
//         dispatch({
//           type: EDIT_SCREEN,
//           payload: updatedScreen.data.updatedScreen,
//         });
//       }
//     } catch (error) {
//       if(error?.response?.data?.message == 'duplicate'){
//         dispatch({
//           type: SCREEN_DUPLICATE_NAMES_ERROR,
//           payload: true
//         })

//         setTimeout(() => {
//           dispatch({
//               type: SCREEN_DUPLICATE_NAMES_ERROR,
//               payload: false
//             })
//         }, 4000)
//       }
//     }
//   };
// };
export const registerScreenFlagOff = () => {
  return async (dispatch) => {
    dispatch({
      type: SCREEN_REGISTER_FLAG_OFF,
      payload: "",
    });
  };
};
// export const getAllScreen = () => {
//   return async (dispatch) => {
//     const { data, status } = await api.get(`/screen/getscreens`);
//     if (status === 200) {
//       dispatch({
//         type: GET_ALL_SCREEN_SUCCESS,
//         payload: data.screens,
//       });
//     }
//   };
// };
export const getAllScreenById = (id, playlistId, page, screenStatus, name, folderId, excludeFolderFilter) => {
  return async (dispatch) => {
    const reqOb = {playlistId: playlistId, page:page, status:screenStatus, name: name, excludeFolderFilter:excludeFolderFilter}
    if(folderId !== '' && folderId) {
      reqOb.folderId = folderId
    }
    const { data, status } = await api.post(`/screen/getscreens/${id}`, reqOb);
    if (status === 200) {
      dispatch({
        type: GET_ALL_SCREEN_SUCCESS,
        payload: {
          screens: data.screens,
          screensCount: data.screensCount,
          filters: data.filters
        },
      });
    }
  };
};

export const getScreenDetails = (id) => {
  return async (dispatch) => {
    try{
      const {status, data} = await api.get(`/screen/getscreendetails/${id}`)
      if(status == 200) {
        dispatch({
          type: GET_ALL_SCREEN_SUCCESS,
          payload: {
            screens: [data.screen]
          }
        })
      }
    } catch (error) {
      dispatch({
        type: GET_SCREEN_DETAILS_ERROR,
        payload: error?.response?.data?.message
      })
      setTimeout(() => {
        dispatch({
          type: GET_SCREEN_DETAILS_ERROR,
          payload: ''
        })
      }, 1000)
    }
  }
}
// /screen/setAsapApkUpdate
export const setAsapApkUpdate = (screenId, status) => {
  return async (dispatch) => {
    try {
      const {data} = await api.post('/screen/setAsapApkUpdate', {
        screenId,
        status
      })
      dispatch({
        type: EDIT_SCREEN,
        payload: data.screen,
      });
    } catch (error) {
      dispatch({
        type: SET_ASAP_UPDATE_FAILED,
        payload: status ? "update_on" : "update_off" 
      })
    }
  }
}

export const updateScreenScheduler = (screen) => {
  return async (dispatch) => {
    dispatch({
      type: EDIT_SCREEN,
      payload: screen,
    });
  }
}

export const setUpdatePendingStatus = (screenId, status) => {
    return async (dispatch) => {
    try {
      const {data} = await api.post('/screen/setUpdatePendingStatus', {
        screenId,
        status
      })
      dispatch({
        type: EDIT_SCREEN,
        payload: data.screen,
      });
    } catch (error) {
      dispatch({
        type: SET_PENDING_STATUS_FAILED,
        payload: true
      })
      setTimeout(() => {
        dispatch({
          type: SET_PENDING_STATUS_FAILED,
          payload: false
        })
      }, 1000)
    }
  }
}
export const getScreenNoDataLogs = (mac) => {
  return async (dispatch) => {
    const {data, status} = await api.post('/screen/getScreenNoDataLogs', {mac: mac})
    if(status == 200){
      dispatch({
        type: SCREEN_NO_DATA_LOGS,
        payload: data.screenNoDataLogs
      })
    }else{
      dispatch({
        type: SCREEN_NO_DATA_LOGS,
        payload: null
      })
    }
  }
}
export const updateScreenLocation = (id, locationDetails) => {
  return async (dispatch) => {
    const updatedScreen = await api.post(`/screen/screenLocationUpdate/${id}`, {
      locationDetails: locationDetails.locationDetails
    });
    if (updatedScreen.status === 200) {
      dispatch({
        type: EDIT_SCREEN,
        payload: updatedScreen.data.updatedScreen,
      });
    }
  };
}
export const getOneScreen = (id) => {
  return async (dispatch) => {
    dispatch({
      type: GET_ONE_SCREEN,
      payload: id,
    });
  };
};
export const screenStatusActive = (mac, status) => {
  return async (dispatch) => {
    dispatch({
      type: SCREEN_STATUS_ACTIVE,
      payload: mac,
    });
    // const updated = await api.patch(
    //   `/screen/screenstatusupdate/${encodeURIComponent(mac)}`,
    //   { status }
    // );
    // if (updated.status === 201) {

    // }
  };
};
export const screenStatusDeActive = (mac, status) => {
  return async (dispatch) => {
    dispatch({
      type: SCREEN_STATUS_DEACTIVE,
      payload: mac,
    });
    // const updated = await api.patch(
    //   `/screen/screenstatusupdate/${encodeURIComponent(mac)}`,
    //   { status }
    // );
    // if (updated.status === 201) {

    // }
  };
};
export const unPairedScreen = (id) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_SCREEN_REQUEST,
      payload: "",
    });
    const { data, status } = await api.patch(`/screen/unpairscreen/${id}`);
    if (status === 201) {
      dispatch({
        type: SCREEN_UNPAIRED,
        payload: data.updated,
      });
    }
  };
};
export const pairedScreen = (id) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_SCREEN_REQUEST,
      payload: "",
    });
    const { data, status } = await api.patch(`/screen/pairscreen/${id}`);
    if (status === 201) {
      dispatch({
        type: SCREEN_PAIRED,
        payload: data.updated,
      });
    }
  };
};
export const screenMoveToFolder = (obj) => {
  return async (dispatch) => {
    const screen = await api.patch(`/screen/screenmovetofolder/${obj.id}`, obj);
    if (screen.status === 201) {
      dispatch({
        type: SCREEN_MOVE_TO_FOLDER,
        payload: screen.data.screen,
      });
    }
  };
};

export const updateScrceenScheduler = (data) => {
  return async (dispatch) => {
    const screenUpdated = await api.patch(`/screen/updateScreenScheduler`, data);
    if (screenUpdated.status === 200) {
      dispatch({
        type: EDIT_SCREEN,
        payload: screenUpdated.data.updatedScreen,
      });
      return screenUpdated.data.updatedScreen
    }
  };
}

export const setActiveScreens = (ids) => {
    return async ( dispatch ) => {
        try {
            const {data, status} = await api.patch(`/screen/setActiveScreens`, {
                ids
            })
            if (status == 200){
                dispatch({
                    type: 'SET_SCREENS_STATUS',
                    payload: data.screens
                })
                return true
            }
        }catch (err) {
            return false
        }
    }
}